export const AdminContent = {
  // Exports section
  exports: {
    sectionTitle: 'Exports',
    exportEvents: {
      label: 'Export Events',
      ariaLabel: 'Export events to CSV',
    },
    exportGuests: {
      label: 'Export Guests',
      ariaLabel: 'Export guests to CSV',
    },
    exportUsers: {
      label: 'Export Users',
      ariaLabel: 'Export users to CSV',
    },
    exportUsersDialog: {
      title: 'Export Users',
      description:
        'Export all user profiles with assigned group import keys and display names.',
      cancel: 'Cancel',
      export: 'Export CSV',
    },
    exportEventsDialog: {
      title: 'Export Events',
      description: 'Select a date range to export event records.',
      presetsLabel: 'Quick Presets',
      customLabel: 'Custom Date Range',
      customFrom: 'From',
      customTo: 'To',
      cancel: 'Cancel',
      export: 'Export CSV',
      presets: {
        today: 'Today',
        thisWeek: 'This Week',
        thisMonth: 'This Month',
        thisQuarter: 'This Quarter',
        thisYear: 'This Year',
        allTime: 'All Time',
      },
    },
  },
};
